import React from 'react';
import {InfoIcon} from 'components';
import {PaymentService} from 'interfaces';
import {getPaymentServiceFee} from 'utils';

const ProcessingFee = ({
  countryCode,
  paymentService,
}: {
  countryCode?: string;
  paymentService: PaymentService;
}) => {
  const details = getPaymentServiceFee(countryCode, paymentService);

  if (details)
    return (
      <div className="bg-[#FFCB5826] text-[#5B4D2D] py-5 px-7 rounded-xl space-y-3 leading-5 mt-5">
        <InfoIcon classes="block mx-auto" width={18} height={18} />
        <p>
          Please be advised that Stripe imposes a {details.fee} payment
          processing fee, in addition to a symbolic fixed fee. These fees will
          be applied to your account for each transaction. For more detailed
          information about Stripe's pricing, services, or other inquiries,
          please visit&nbsp;
          <a
            className="text-blue-600 underline capitalize"
            href={details.pricing_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {paymentService} Pricing
          </a>
          .
        </p>
      </div>
    );

  return null;
};

export default ProcessingFee;
